import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

const ProtectedRoute: React.FC = () => {
  const { entityName } = useParams<{ entityName: string }>();
  const isAuthenticated = useSelector((state: RootState) => state.user.userAuth);

  return isAuthenticated ? <Outlet /> : <Navigate to={`/${entityName}`} />;
};

export default ProtectedRoute;